import React, { useState, useEffect } from 'react';

import { ChevronDown, ChevronUp } from 'lucide-react';

import { Popover, PopoverContent, PopoverTrigger, Input, Button, Checkbox } from '#/components/ui';

const FilterDropdown = ({ label, options = [], selected = [], setSelected, isMulti = false, showActive = false }) => {
    const [search, setSearch] = useState('');
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (showActive) setOpen(true);
    }, [showActive]);

    const toggleOption = value => {
        if (isMulti) {
            setSelected(selected.includes(value) ? selected.filter(item => item !== value) : [...selected, value]);
        } else {
            setSelected(selected[0] === value ? [] : [value]);
        }
    };

    const filteredOptions = options?.filter(option => option?.name?.toLowerCase()?.includes(search.toLowerCase()));

    const DropdownUI = (
        <div className='w-full max-h-80 overflow-auto p-2 bg-white border border-gray-200 rounded-md shadow-sm'>
            <Input
                placeholder={`Search ${label}`}
                value={search}
                onChange={e => setSearch(e.target.value)}
                className='mb-2'
            />
            <div className='space-y-1'>
                {filteredOptions?.map(option => (
                    <div key={option.value} className='flex items-center space-x-2'>
                        <Checkbox
                            id={option.name}
                            checked={selected.includes(option.name)}
                            onCheckedChange={() => toggleOption(option.name)}
                        />
                        <label htmlFor={option.name} className='text-sm font-medium'>
                            {option.name}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );

    if (showActive) {
        return DropdownUI;
    }

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button variant='outline' className='w-52 text-gray400 cursor-pointer justify-between bg-white'>
                    {label}
                    <span className='text-muted-foreground text-xs'>{open ? <ChevronUp /> : <ChevronDown />}</span>
                </Button>
            </PopoverTrigger>
            <PopoverContent className='w-52 p-0'>{DropdownUI}</PopoverContent>
        </Popover>
    );
};

export { FilterDropdown };
